module.exports = __webpack_public_path__ + "assets/img/19_881_big.43b5d76b.jpg";